import { UpdateIcon } from "../../Icons"
import '../index.css'

interface UpdateChipProps {
  onClick?: () => void
  label?: string
  outlineColor?: string
  disabled?: boolean
}

const UpdateChip: React.FC<UpdateChipProps> = ({
  onClick,
  label,
  outlineColor = '#c0bcbc',
  disabled }) => {

  return (
    <div>
      <button disabled={disabled} style={{ border: `1px solid ${outlineColor}` }} className="chip-btn" onClick={onClick}>
        <UpdateIcon className="chip-btn__icon" />
        {label}
      </button>
    </div>
  )
}

export default UpdateChip